import React from 'react';
import { useFadeInOnScroll } from '../../hooks/useScrollEffects';
import './SecretsSection.css';

const SecretsSection = () => {
  // Hooks para efeitos de scroll com layers sincronizados
  const { isVisible: titleVisible, elementRef: titleRef, transformStyle: titleTransform } = useFadeInOnScroll('TITLE');
  const { isVisible: secretsVisible, elementRef: secretsRef, transformStyle: secretsTransform } = useFadeInOnScroll('CONTENT');
  const { isVisible: ctaVisible, elementRef: ctaRef, transformStyle: ctaTransform } = useFadeInOnScroll('BUTTON');

  const scrollToHero = () => {
    const heroSection = document.getElementById('hero-section');
    if (heroSection) {
      heroSection.scrollIntoView({ behavior: 'smooth' });
    }
  };
  const secrets = [
    {
      number: "1",
      title: "Você não precisa começar sozinho — e nem deve."
    },
    {
      number: "2", 
      title: "Você não precisa ser um gênio — só precisa de um método simples."
    },
    {
      number: "3",
      title: "Rotina e disciplina vencem talento — e vão te dar liberdade."
    }
  ];

  return (
    <div className="secrets-section">
      <div className="secrets-background-charts">
        <div className="secrets-blur-effects">
          {Array.from({length: 10}, (_, i) => (
            <div key={i} className={`secrets-blur-ellipse ellipse-${i + 1}`}></div>
          ))}
        </div>
      </div>
      
      <div className="secrets-content">
        <h2 
          ref={titleRef}
          className={`section-title scroll-fade-in ${titleVisible ? 'visible' : ''}`}
          style={titleTransform}
        >
          Você vai descobrir os 3 segredos para lucrar com consistência no mercado
        </h2>
        
        <div 
          ref={secretsRef}
          className={`secrets-grid scroll-fade-in ${secretsVisible ? 'visible' : ''}`}
          style={secretsTransform}
        >
          {secrets.map((secret, index) => (
            <div key={index} className="secret-card">
              <div className="secret-card-content">
                <div className="secret-content-inner">
                  <h3 className="secret-title">
                    {secret.title}
                  </h3>
                </div>
              </div>
              <div className="secret-blur-bottom"></div>
              <div className="secret-blur-top"></div>
              <div className="secret-number">
                {secret.number}
              </div>
            </div>
          ))}
        </div>
        
        <div className="secrets-decorative-blur"></div>
        
        <button 
          ref={ctaRef}
          className={`cta-button scroll-fade-in ${ctaVisible ? 'visible' : ''}`}
          style={ctaTransform}
          onClick={scrollToHero}
        >
          Vagas Limitadas!
        </button>
      </div>
    </div>
  );
};

export default SecretsSection;
